
import { defineComponent } from 'vue'
import Header from './Header.vue'
import Bar from './Bar.vue'

export default defineComponent({
  components: {
    Header,
    Bar,
  },
  props: {
    repo: {
      type: Object as () => any,
      required: true,
    },
    langs: {
      type: Object as () => { [key: string]: { [key: string]: number } },
      required: false,
    },
  },
})
